module.exports = __webpack_public_path__ + "img/business.35e43ecb.svg";